<div class="bg-branding-primary text-branding-50" [class]="state.tabCommonClasses()">
  <div
    class="transition-opacity duration-100 h-full flex flex-col items-center max-md:overflow-y-auto mib-scrollbar"
    [class.opacity-0]="isMinimized()"
    [class.hidden]="isHidden()"
  >
    <!-- Desktop header -->
    <div
      class="border-branding-700 sticky top-0 px-4 md:px-6 max-md:hidden"
      [class]="state.tabHeaderClasses"
      [class.border-b]="hasMessages()"
    >
      <mib-button
        size="medium"
        mode="flat"
        theme="ai"
        iconOnly
        mibTooltip="Minimize"
        mibTooltipShowDelay="500"
        (click)="toggleTab()"
      >
        <svg mib-chevron-right-icon></svg>
      </mib-button>
    </div>

    <app-chat class="flex flex-1 min-h-0 w-full justify-center"></app-chat>
  </div>
</div>
